
import { supabase } from '../../client';
import { EcomPaymentSettings } from '../types';

/**
 * Crée les paramètres de paiement par défaut pour une boutique
 */
export async function createDefaultPaymentSettings(shopId: string): Promise<EcomPaymentSettings | null> {
  try {
    // Vérifier à nouveau si des paramètres existent déjà (double check pour éviter les doublons)
    const { data: existingSettings } = await supabase
      .from('ecom_payment_settings')
      .select('*')
      .eq('shop_id', shopId)
      .limit(1);
    
    if (existingSettings && existingSettings.length > 0) {
      console.log('[createDefaultPaymentSettings] Settings already exist, returning existing:', existingSettings[0]);
      return existingSettings[0];
    }
    
    const defaultSettings = {
      shop_id: shopId,
      cod_enabled: true,
      stripe_enabled: false,
      paypal_enabled: false
    };

    const { data, error } = await supabase
      .from('ecom_payment_settings')
      .insert(defaultSettings)
      .select('*')
      .single();

    if (error) {
      console.error('[createDefaultPaymentSettings] Error:', error);
      return null;
    }

    return data;
  } catch (error) {
    console.error('[createDefaultPaymentSettings] Exception:', error);
    return null;
  }
}
